




























/**
 * For use this component you have to fill store customers items;
*/
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { GET_ITEMS, ITEMS_REQUEST, LOADING } from '@/store';
import { CustomerModel } from '@/store/types/work/Providers';
import { namespace } from 'vuex-class';
import { NAMESPACE } from '@/store/models/work/enterprise/customers';
const customersStore = namespace(NAMESPACE);

@Component
export default class SelectCustomer extends Vue {
  @Prop() public value: any;
  @customersStore.Getter(GET_ITEMS) customers!:CustomerModel[];
  @customersStore.Getter(LOADING) customersLoading!: boolean;
  @customersStore.Action(ITEMS_REQUEST) customersRequest: any;
  search = null;

  @Watch('search')
  changeSearch (val:string|null, old: string|null) {
    // Lazily load input items
    this.customersRequest({ filters: { search: val }, per_page: 30 });
  }

  created () {
    this.$nextTick(() => {
      if (!this.customers.length) {
        this.customersRequest({ per_page: 30 });
      }
    });
  }
}
